import { useEffect, useRef, useState } from "react";
import { ArrowLeftOutlined, LoadingOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Input, Row, Col, Checkbox, Typography } from 'antd';
import { Button } from "shared/components/Button";
import TextArea from 'antd/es/input/TextArea';
import React from 'react';
import { Form } from 'react-router-dom';
import { Header } from 'shared/views/Header';
import { Label } from 'Components';
import { toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";
import HelpSupport from 'assets/svg/chat.svg'
import Call from 'assets/svg/call.svg'
import Email from 'assets/svg/email.svg'
import BgBottomLeftIcon from 'assets/svg/bgBottomLeft.svg'
import BgTopRightIcon from 'assets/svg/bgTopRight.svg'
import { useTranslation } from "contexts/TranslationContext";
import { Formik } from "formik";
import * as Yup from "yup";
import routes from "shared/constants/routes";
import env from "shared/constants/env";

const { Text } = Typography;


const ComplaintSubmitSuccess = ({ }) => {
    const navigate = useNavigate();
    const { translate } = useTranslation();
    return (
        <div className="flex items-center justify-center min-h-screen bg-[#F3F4F6] w-full">
            <div className="bg-white rounded-2xl shadow-md px-8 py-12 max-w-md w-full flex flex-col items-center">
                <div className="flex items-center justify-center mb-6">
                    <div className="bg-green-100 rounded-full p-5 flex items-center justify-center">
                        <CheckCircleOutlined className="text-green-500 text-4xl" />
                    </div>
                </div>
                <h2 className="text-green-600 text-2xl font-bold mb-4 text-center">{translate('COMPLAINTS.SUBMITTED')}</h2>
                <p className="text-gray-700 text-center mb-2">
                    {translate('COMPLAINTS.SUCCESS_PARA1')}<br />
                    {translate('COMPLAINTS.SUCCESS_PARA2')}
                </p>
                <button
                    className="mt-6 bg-yellow-400 hover:bg-yellow-500 text-white font-bold py-3 px-8 rounded-lg w-full transition"
                    onClick={() => navigate(-1)}
                >
                    {translate('COMPLAINTS.BACK')}
                </button>
            </div>
        </div>
    );
};


const OtpVerification = (props) => {
    const [seconds, setSeconds] = useState(60);
    const [otp, setOtp] = useState(['', '', '', '']);
    const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
    const { translate, language } = useTranslation();
    const isArabic = language.code === 'ar' ? true : false;

    const otpRef1 = useRef(null);
    const otpRef2 = useRef(null);
    const otpRef3 = useRef(null);
    const otpRef4 = useRef(null);

    const countdown = (intervalId) => {
        if (seconds <= 0) {
            toast.error(translate('COMPLAINT.TIMEOUT'));
            clearInterval(intervalId);
        } else {
            setSeconds(seconds - 1);
        }
    };

    useEffect(() => {
        const intervalId = setInterval(() => {
            countdown(intervalId);
        }, 1000);

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [seconds]); // eslint-disable-line


    const handleOtpChange = (value, index) => {
        setOtp((prevOtp) => prevOtp.map((_, i) => (index === i ? value : _)));

        // Auto-focus next input field
        switch (index) {
            case 0:
                otpRef2.current.focus();
                break;
            case 1:
                otpRef3.current.focus();
                break;
            case 2:
                otpRef4.current.focus();
                break;
            default:
                return;
        }
    };


    const validateOtp = async () => {
        const enteredOtp = otp.join('');
        setIsVerifyingOtp(true);

        console.log("OTP entered:", process.env);

        try {
            const response = await fetch(`${env.API_ENDPOINT}auth/validate-complaint-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': process.env.X_API_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtb2JpbGUiOiIqKk1PQkksTEVKV1QqKiIsImlhdCI6MTczNjg2OTEwNn0.vMeo3rifCPd8vh_Cwtl4TMT1i0IgI0AKWkvH8PQ3TBE"
                },
                body: JSON.stringify({
                    otp_reference: props.otp_reference,
                    otp: enteredOtp
                })
            });
            if (!response.ok) {
                const errorData = await response.json();
                toast.error(errorData?.message || errorData?.error || translate('COMPLAINTS.ERROR'));
                setIsVerifyingOtp(false);
                setSeconds(0);
                return
            }

            const data = await response.json();
            if (data?.success) {
                props.setVerified() //OTP for phone number now verified
                toast.success(data?.message || translate('COMPLAINTS.VERIFY_PHONE_SUCCESS'));
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);
            toast.error(error.message || error.error || translate('COMPLAINTS.VERIFY_PHONE_ERROR'));
        } finally {
            setIsVerifyingOtp(false);
        }
    };


    const resendOtp = async () => {
        try {
            const response = await fetch(`${env.API_ENDPOINT}auth/resend-complaint-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': process.env.X_API_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtb2JpbGUiOiIqKk1PQkksTEVKV1QqKiIsImlhdCI6MTczNjg2OTEwNn0.vMeo3rifCPd8vh_Cwtl4TMT1i0IgI0AKWkvH8PQ3TBE"
                },
                body: JSON.stringify({
                    otp_reference: props.otp_reference,
                    lang: isArabic ? 'ar' : 'en',
                    phoneNum: props.phoneNum
                })
            });
            if (!response.ok) {
                const errorData = await response.json();
                toast.error(errorData?.message || errorData?.error || translate('COMPLAINTS.ERROR'));
                return
            }

            const data = await response.json();
            if (data?.success) {
                toast.success(data?.message || translate('COMPLAINTS.SUBMIT_SUCCESS'));
                setOtp(['', '', '', '']); // Reset OTP input fields
                setSeconds(60);
                // setSubmitLoading(false);
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);
            toast.error(error.message || error.error || translate('COMPLAINTS.VERIFY_PHONE_ERROR'));
        } finally {
            // setIsVerifyingOtp(false);
        }
    }


    return (
        <Col xs={24} md={24} className="my-4">
            <div className="p-4">
                <p className="text-gray-700 mb-4">{translate('COMPLAINTS.VERIFY_DESC')}</p>

                <div className="flex items-center justify-between mb-4 flex-col sm:flex-row" dir="ltr">
                    <div className="flex gap-2 flex-1">
                        {[otpRef1, otpRef2, otpRef3, otpRef4].map((ref, index) => (
                            <input
                                dir="ltr"
                                key={index}
                                ref={ref}
                                maxLength={1}
                                type="text"
                                pattern="[0-9]*"
                                inputMode="numeric"
                                value={otp[index]}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d$/.test(value)) {
                                        // console.log("OTP value:", e.target.value);
                                        handleOtpChange(value, index);
                                    } else {
                                        e.target.value = '';
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (
                                        !/^\d$/.test(e.key) &&
                                        e.key !== 'Backspace' &&
                                        e.key !== 'Tab' &&
                                        e.key !== 'ArrowLeft' &&
                                        e.key !== 'ArrowRight'
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                name={`otp${index + 1}`}
                                id={`otp${index + 1}`}
                                onWheel={(e) => e.target.blur()} // disables mouse wheel input
                                onPaste={(e) => e.preventDefault()} // disables pasting
                                className="w-full h-12 text-center text-xl border border-gray-300 rounded-md focus:outline-none focus:border-primary"
                                required
                            />
                        ))}
                    </div>

                    <div className="mt-4 sm:my-4 sm:ml-4 sm:mr-4">
                        <Button
                            className={"tamweel-button w-full disabled:border-gray-400 disabled:bg-transparent disabled:text-gray-400 min-w-[189px]"}
                            mode="complaintSecondary"
                            onClick={() => validateOtp()}
                            disabled={isVerifyingOtp || otp.some(digit => digit === '') || seconds <= 0}
                        >
                            {isVerifyingOtp ? <LoadingOutlined /> : translate('COMPLAINTS.VALIDATE')}
                        </Button>
                    </div>
                </div>
                <div className="text-center text-gray-500 font-bold text-3xl">
                    00:{String(seconds % 60).padStart(2, '0')}
                </div>
                {seconds <= 0 ?
                    <div className="text-center text-gray-400 font-bold text-sm cursor-not-allowed">
                        <a onClick={() => resendOtp()} className="text-center text-primary font-bold text-sm hover:text-primary">
                            {translate('SIGN_IN.RESEND_CODE')}
                        </a>
                    </div>
                    :
                    <div className="text-center text-gray-400 font-bold text-sm cursor-not-allowed">
                        {translate('SIGN_IN.RESEND_CODE')}
                    </div>
                }
            </div>
        </Col >
    );
};

export default function Complaints() {
    const { translate, language } = useTranslation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [showOtpVerification, setShowOtpVerification] = useState(false);
    const [otp_reference, setOtpReference] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    let isArabic = language.code === 'ar' ? true : false;

    const setVerified = () => {
        setShowOtpVerification(false);
        setIsVerified(true);
    }

    const initialValues = {
        cust_name: '',
        customer_city: '',
        id_iqama: '',
        cust_email: '',
        cust_phone: '',
        complaint_details: ''
    };


    const verifyPhone = async (phoneNum) => {
        setIsLoading(true);
        console.log("OTP entered:", process.env);
        try {
            const response = await fetch(`${env.API_ENDPOINT}auth/get-complaint-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': process.env.X_API_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtb2JpbGUiOiIqKk1PQkksTEVKV1QqKiIsImlhdCI6MTczNjg2OTEwNn0.vMeo3rifCPd8vh_Cwtl4TMT1i0IgI0AKWkvH8PQ3TBE"
                },
                body: JSON.stringify({
                    lang: isArabic ? 'ar' : 'en',
                    phoneNum: phoneNum
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                toast.error(errorData?.message || errorData?.error || translate('COMPLAINTS.VERIFY_PHONE_ERROR'));
                setIsLoading(false);
                return
            }

            const data = await response.json();
            if (data?.success) {
                setOtpReference(data.otp_reference);
                setShowOtpVerification(true);
                toast.success(data?.message || translate('COMPLAINTS.VERIFY_PHONE_SUCCESS'));
            }
        } catch (error) {
            console.error("Error verifying phone:", error);
            toast.error(error.message || error.error || translate('COMPLAINTS.VERIFY_PHONE_ERROR'));
        } finally {
            setIsLoading(false);
        }
    };

    const onSubmit = async (values) => {
        setSubmitLoading(true);
        try {
            const response = await fetch(`${env.API_ENDPOINT}auth/submit-complaint`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': process.env.X_API_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtb2JpbGUiOiIqKk1PQkksTEVKV1QqKiIsImlhdCI6MTczNjg2OTEwNn0.vMeo3rifCPd8vh_Cwtl4TMT1i0IgI0AKWkvH8PQ3TBE"
                },
                body: JSON.stringify({ ...values, source: 'WEB', otp_reference: otp_reference })
            });

            if (!response.ok) {
                const errorData = await response.json();
                toast.error(errorData?.message || errorData?.error || translate('COMPLAINTS.SUBMIT_ERROR'));
                setSubmitLoading(false);
                return
            }

            const data = await response.json();
            if (data?.success) {
                setSubmitLoading(false);
                toast.success(data?.message || translate('COMPLAINTS.SUBMIT_SUCCESS'));
                setShowSuccess(true);
            }
        } catch (error) {
            console.error("Error submitting complaint:", error);
            toast.error(error?.message || error?.error || translate('COMPLAINTS.SUBMIT_ERROR'));
            setSubmitLoading(false);
        }
    }

    const schema = Yup.object().shape({
        cust_name: Yup.string()
            .trim()
            .max(100, translate('COMPLAINTS.VALIDATION.NAME_MAX_LENGTH'))
            .matches(
                /^[\u0600-\u06FFa-zA-Z\s]+$/,
                translate('COMPLAINTS.VALIDATION.NAME_ONLY_LETTERS')
            )
            .required(translate('COMPLAINTS.VALIDATION.NAME_REQUIRED')),

        cust_phone: Yup.string()
            .matches(/^966\d{9}$/, translate('COMPLAINTS.VALIDATION.PHONE_FORMAT'))
            .required(translate('COMPLAINTS.VALIDATION.PHONE_REQUIRED')),

        cust_email: Yup.string()
            .trim()
            .lowercase()
            .email(translate('COMPLAINTS.VALIDATION.EMAIL_FORMAT'))
            .max(55, translate('COMPLAINTS.VALIDATION.EMAIL_MAX_LENGTH'))
            .required(translate('COMPLAINTS.VALIDATION.EMAIL_REQUIRED')),

        complaint_details: Yup.string()
            .trim()
            .max(4000, translate('COMPLAINTS.VALIDATION.DETAILS_MAX_LENGTH'))
            .matches(
                /^[\u0600-\u06FFa-zA-Z0-9\s.,]+$/,
                translate('COMPLAINTS.VALIDATION.DETAILS_ALLOWED_CHARS')
            )
            .required(translate('COMPLAINTS.VALIDATION.DETAILS_REQUIRED')),

        id_iqama: Yup.string()
            .matches(/^\d{10}$/, translate('COMPLAINTS.VALIDATION.ID_FORMAT'))
            .test(
                "starts-with-1-or-2",
                translate('COMPLAINTS.VALIDATION.ID_START_WITH'),
                (value) => value?.startsWith("1") || value?.startsWith("2")
            )
            .required(translate('COMPLAINTS.VALIDATION.ID_REQUIRED')),

        customer_city: Yup.string()
            .trim()
            .max(100, translate('COMPLAINTS.VALIDATION.CITY_MAX_LENGTH'))
            .matches(/^[\u0600-\u06FFa-zA-Z\s]+$/, translate('COMPLAINTS.VALIDATION.CITY_ONLY_LETTERS'))
    });

    const HelpAndContact = () => {
        return (
            <div className="my-2">
                <div className="mt-6 flex flex-col sm:flex-row gap-2 items-start sm:items-center sm:justify-center p-2 sm:bg-[#EEEEEE]">
                    <div className="flex flex-row items-center">
                        <img src={Call} alt="call" className="rounded-lg p-2" />
                        <a
                            href="tel:920005477"
                            className="text-xs text-black ml-2 font-medium hover:underline"
                        >
                            {translate("SIGN_IN.HELP_LINE_CALL")}
                        </a></div>
                    <div className="hidden sm:flex flex-row items-center">
                        <p className="text-xs text-black">{translate("SIGN_IN.OR")}</p>
                    </div>

                    <div className="flex flex-row items-center">
                        <img src={Email} alt="email" className="rounded-lg p-2" />
                        <p className="text-xs text-black ml-2">{translate("SIGN_IN.HELP_LINE_EMAIL")}</p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <section className="relative min-h-full bg-[#F3F4F6] overflow-hidden">
            {/* Top-right image */}
            <img
                src={BgTopRightIcon}
                alt="Top Right Decoration"
                className="absolute top-0 right-0 w-64 md:w-64 lg:w-64 z-0"
            />

            {/* Bottom-left image */}
            <img
                src={BgBottomLeftIcon}
                alt="Bottom Left Decoration"
                className="absolute bottom-0 left-0 w-64 md:w-64 lg:w-64 z-0"
            />

            <Header />
            <div className="relative z-10 flex flex-col h-full w-full pb-10">
                <div className="flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 py-8 md:py-12 min-h-screen w-full">
                    {showSuccess ?
                        <ComplaintSubmitSuccess />
                        : <div className="w-full max-w-[90%] md:max-w-6xl">
                            <div className="bg-white shadow-md rounded-3xl px-8 py-8 md:px-10 md:py-10 lg:px-12 lg:py-12">
                                <h1 className="form-header-text tamweel-text-22 font-bold leading-tight tracking-tight text-primary uppercase">
                                    {translate('COMPLAINTS.TITLE')}
                                </h1>

                                <div className="bg-secondary w-9 h-1" />

                                <div className="form-header-title-wrapper">
                                    <h2 className="uppercase text-black text-2xl sm:text-3xl font-bold my-6">
                                        {translate('COMPLAINTS.COMPLAINT_SUBMISSION')}
                                    </h2>
                                    <div className="text-gray-400 text-sm mb-6">
                                        {translate("COMPLAINTS.COMPLAINT_DESC")}
                                    </div>
                                </div>

                                <Formik
                                    initialValues={initialValues}
                                    onSubmit={onSubmit}
                                    validationSchema={schema}
                                    validateOnChange={false}
                                    validateOnBlur={true}
                                    validateOnMount={true}
                                >
                                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isValid, dirty }) => (
                                        <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <div>
                                                        <Label
                                                            label={translate('COMPLAINTS.FIELDS.FULL_NAME')}
                                                            required={true}
                                                            name={translate('COMPLAINTS.FIELDS.FULL_NAME')}
                                                        />
                                                        <Input
                                                            className={'tamweel-base-input'}
                                                            name="cust_name"
                                                            id="cust_name"
                                                            status={touched.cust_name && errors.cust_name ? "error" : null}
                                                            onBlur={handleBlur}
                                                            placeholder={translate('COMPLAINTS.PLACEHOLDERS.FULL_NAME')}
                                                            maxLength={100}
                                                            onChange={handleChange}
                                                            value={values.cust_name}
                                                        />
                                                        {
                                                            touched.cust_name && errors.cust_name &&
                                                            <Text type="danger">{errors.cust_name}</Text>
                                                        }
                                                    </div>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                    <div>
                                                        <Label
                                                            label={translate('COMPLAINTS.FIELDS.ID')}
                                                            required={true}
                                                            name={translate('COMPLAINTS.FIELDS.ID')}
                                                        />
                                                        <Input
                                                            className={'tamweel-base-input'}
                                                            name="id_iqama"
                                                            id="id_iqama"
                                                            status={touched.id_iqama && errors.id_iqama ? "error" : null}
                                                            onBlur={handleBlur}
                                                            placeholder={translate('COMPLAINTS.PLACEHOLDERS.ID')}
                                                            maxLength={10}
                                                            pattern="[0-9]*"
                                                            onKeyDown={(e) => {
                                                                if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                            onPaste={(e) => {
                                                                const pasted = e.clipboardData.getData('Text');
                                                                if (!/^\d+$/.test(pasted)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                            onChange={handleChange}
                                                            value={values.id_iqama}
                                                        />
                                                        {
                                                            touched.id_iqama && errors.id_iqama &&
                                                            <Text type="danger">{errors.id_iqama}</Text>
                                                        }
                                                    </div>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                    <div>
                                                        <Label
                                                            label={translate('COMPLAINTS.FIELDS.CITY')}
                                                            required={false}
                                                            name={translate('COMPLAINTS.FIELDS.CITY')}
                                                        />
                                                        <Input
                                                            className={'tamweel-base-input'}
                                                            name="customer_city"
                                                            id="customer_city"
                                                            status={touched.customer_city && errors.customer_city ? "error" : null}
                                                            onBlur={handleBlur}
                                                            placeholder={translate('COMPLAINTS.PLACEHOLDERS.CITY')}
                                                            onChange={handleChange}
                                                            value={values.customer_city}
                                                        />
                                                        {
                                                            touched.customer_city && errors.customer_city &&
                                                            <Text type="danger">{errors.customer_city}</Text>
                                                        }
                                                    </div>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                    <div>
                                                        <Label
                                                            label={translate('COMPLAINTS.FIELDS.EMAIL')}
                                                            required={true}
                                                            name={translate('COMPLAINTS.FIELDS.EMAIL')}
                                                        />
                                                        <Input
                                                            className={'tamweel-base-input'}
                                                            name="cust_email"
                                                            id="cust_email"
                                                            status={touched.cust_email && errors.cust_email ? "error" : null}
                                                            type="email"
                                                            onBlur={handleBlur}
                                                            placeholder={translate('COMPLAINTS.PLACEHOLDERS.EMAIL')}
                                                            onChange={handleChange}
                                                            value={values.cust_email}
                                                        />
                                                        {
                                                            touched.cust_email && errors.cust_email &&
                                                            <Text type="danger">{errors.cust_email}</Text>
                                                        }
                                                    </div>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                    <div>
                                                        <Label
                                                            label={translate('COMPLAINTS.FIELDS.PHONE')}
                                                            required={true}
                                                            name={translate('COMPLAINTS.FIELDS.PHONE')}
                                                        />
                                                        <Input
                                                            className={'tamweel-base-input'}
                                                            name="cust_phone"
                                                            id="cust_phone"
                                                            status={touched.cust_phone && errors.cust_phone ? "error" : null}
                                                            onBlur={handleBlur}
                                                            placeholder={translate('COMPLAINTS.PLACEHOLDERS.PHONE')}
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                                                if (value.length <= 12) { // Limit to 12 characters
                                                                    console.log("Phone value:", value);
                                                                    setPhoneNumber(value);
                                                                    handleChange(e);
                                                                }
                                                            }
                                                            }
                                                            value={values.cust_phone}
                                                            pattern="[0-9]*"
                                                            onKeyDown={(e) => {
                                                                if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                            onPaste={(e) => {
                                                                const pasted = e.clipboardData.getData('Text');
                                                                if (!/^\d+$/.test(pasted)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                            disabled={isVerified || showOtpVerification}
                                                        />
                                                        {
                                                            touched.cust_phone && errors.cust_phone &&
                                                            <Text type="danger">{errors.cust_phone}</Text>
                                                        }
                                                    </div>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Button
                                                        className="tamweel-button w-full md:mt-8 lg:mt-8 disabled:border-gray-400 disabled:bg-transparent disabled:text-gray-400"
                                                        mode="complaintSecondary"
                                                        onClick={() => verifyPhone(values.cust_phone)}
                                                        disabled={isLoading || !values.cust_phone || errors.cust_phone || showOtpVerification || isVerified}

                                                    >
                                                        {isLoading ? <LoadingOutlined /> : translate('COMPLAINTS.VERIFY')}
                                                    </Button>
                                                </Col>

                                                {showOtpVerification &&
                                                    <OtpVerification otp_reference={otp_reference} phoneNum={phoneNumber} setVerified={setVerified} />
                                                }

                                                {isVerified &&
                                                    <Col xs={24} className="flex align-middle justify-start text-green-500">
                                                        <CheckCircleOutlined className="text-lg sm:text-2xl mr-2 ml-2" />
                                                        <span className="text-sm sm:text-lg font-bold align-middle">{translate('COMPLAINTS.PHONE_VERIFIED')}</span>
                                                    </Col>

                                                }


                                                <Col xs={24}>
                                                    <div>
                                                        <Label
                                                            label={translate('COMPLAINTS.FIELDS.COMPLAINT_DETAILS')}
                                                            required={true}
                                                            name={translate('COMPLAINTS.FIELDS.COMPLAINT_DETAILS')}
                                                        />
                                                        <TextArea
                                                            className={'tamweel-base-input'}
                                                            name="complaint_details"
                                                            id="complaint_details"
                                                            status={touched.complaint_details && errors.complaint_details ? "error" : null}
                                                            onBlur={handleBlur}
                                                            placeholder={translate('COMPLAINTS.PLACEHOLDERS.COMPLAINT_DETAILS')}
                                                            rows={4}
                                                            maxLength={4000}
                                                            onChange={handleChange}
                                                            value={values.complaint_details}
                                                        />
                                                        {
                                                            touched.complaint_details && errors.complaint_details &&
                                                            <Text type="danger">{errors.complaint_details}</Text>
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>

                                            <div className={"w-full flex flex-col items-center sm:items-start"}>
                                                <Button
                                                    className={"tamweel-button mt-4 w-full max-w-[217px]"}
                                                    type="submit"
                                                    disabled={isLoading || !isValid || !isVerified}
                                                    // disabled={submitLoading || !isValid}
                                                    block
                                                >
                                                    {
                                                        submitLoading ?
                                                            <LoadingOutlined /> :
                                                            translate('COMPLAINTS.SUBMIT')
                                                    }
                                                </Button>
                                            </div>
                                            <div className="flex flex-col">
                                                <HelpAndContact />
                                            </div>

                                        </form>
                                    )}
                                </Formik>
                            </div>
                        </div>}
                </div>
            </div>
        </section>
    );
}
